import type { Kandidat } from './typen';

/** Semikolon-getrennt, weil Excel und Word im deutschen Gebietsschema das erwarten. */
const TRENNER = ';';

function feld(wert: string): string {
  const w = wert || '';
  // Nur maskieren, wenn noetig — sonst stehen ueberall unnoetige Anfuehrungszeichen.
  if (!w.includes(TRENNER) && !w.includes('"') && !w.includes('\n')) return w;
  return `"${w.split('"').join('""')}"`;
}

/**
 * Adressliste der Empfaenger OHNE E-Mail-Adresse, als CSV fuer den Serienbrief.
 * Gegenstueck zur Druckansicht — dieselben Daten, andere Ausgabe.
 */
export function baueCsv(ohneAdresse: Kandidat[]): string {
  const kopf = ['Name', 'Strasse', 'PLZ', 'Ort', 'Objekt', 'Einheit'].join(TRENNER);
  const zeilen = (ohneAdresse || []).map((k) =>
    // Strasse und Hausnummer stehen im Brief in EINER Zeile — deshalb hier auch eine
    // Spalte. Die Einheit gehoert dazu, damit der Brief im richtigen Briefkasten landet;
    // bei Eigentuemern bleibt sie leer.
    [
      k.name,
      [k.strasse, k.hausnummer].filter(Boolean).join(' '),
      k.plz,
      k.stadt,
      k.objekt_bezeichnung,
      k.einheit_bezeichnung,
    ].map(feld).join(TRENNER),
  );
  const alle = [kopf, ...zeilen];
  // Leere Liste: nur Kopf mit Newline. Mit Inhalten: ohne finales Newline.
  return alle.join('\n') + (zeilen.length === 0 ? '\n' : '');
}
